import { ChangeEvent } from 'react';
import { Input, Form as AntForm } from 'antd';
import { AnySchema } from 'yup';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { formHelpers } from '@helpers/formHelpers';

const { Item: FormItem } = AntForm;
const { TextArea } = Input;

interface HSMSInputProps {
  label?: string;
  name: string;
  type?: string;
  errorField?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: AnySchema<Record<string, unknown> | undefined>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customOnChange?: (value: any) => void;
  icon?: React.ReactNode;
  placeholder?: string;
  secure?: boolean;
  min?: number;
  textArea?: boolean;
  rows?: number;
  disabled?: boolean;
  defaultValue?: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: FieldErrors<any>;
  id?: string;
}

export const HSMSInput = ({
  label,
  name,
  type = 'text',
  control,
  validationSchema,
  icon,
  placeholder,
  secure,
  min = 0,
  textArea,
  errors,
  rows,
  disabled,
  defaultValue,
  errorField,
  customOnChange,
  id,
}: HSMSInputProps) => {
  const fieldOnChange = (
    event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (...event: any[]) => void,
  ) => {
    const { value } = event.target;

    if (customOnChange) {
      customOnChange(value);
    }

    onChange(value);
  };

  return (
    <div id={id}>
      <FormItem
        required={validationSchema && formHelpers.isRequired(validationSchema, name)}
        label={label}
        validateStatus={errors && errors[errorField || name] ? 'error' : ''}
        help={errors && errors[errorField || name]?.message}
        labelCol={{ span: 24 }}
      >
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ onChange, onBlur, value }) => {
            if (secure) {
              return (
                <Input.Password
                  name={name}
                  placeholder={placeholder}
                  type={type}
                  prefix={icon}
                  disabled={disabled}
                  onChange={(event) => fieldOnChange(event, onChange)}
                  onBlur={onBlur}
                  value={value}
                />
              );
            }

            if (textArea) {
              return (
                <TextArea
                  name={name}
                  placeholder={placeholder}
                  disabled={disabled}
                  onChange={(event) => fieldOnChange(event, onChange)}
                  onBlur={onBlur}
                  value={value}
                  rows={rows || 6}
                />
              );
            }

            return (
              <Input
                name={name}
                placeholder={placeholder}
                disabled={disabled}
                type={type}
                min={min}
                prefix={icon}
                onChange={(event) => fieldOnChange(event, onChange)}
                onBlur={onBlur}
                value={value}
              />
            );
          }}
        />
      </FormItem>
    </div>
  );
};
